export default __webpack_public_path__ + "static/media/blackdownarrow.4f6cb0bd.png";